// src/components/home/DigitalProductsSection.jsx
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Check, Trophy } from 'lucide-react';
import Images from '../Images';

const DigitalProductsSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const features = [
    "Interactive quizzes with real-time scoring",
    "Customizable themes and questions",
    "Exciting prizes and rewards",
    "Multi-platform accessibility (web and mobile)",
    "Detailed analytics and insights"
  ];

  return (
    <section id="products" className="py-20 bg-white">
      <div className="max-w-8xl mx-auto px-6 lg:px-16">
        <div className="text-center mb-12">
          <span className="text-brand-orange text-sm font-semibold tracking-wider">DIGITAL PRODUCTS</span>
          <h2 className="text-3xl font-bold text-gray-900 mt-2 mb-4">Digital Products</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Discover our innovative digital products designed to enhance your experience and drive engagement.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <h3 className="text-4xl font-bold text-gray-900 mb-6">Who Wants To Play</h3>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Engage your audience with our interactive trivia game platform. Test knowledge, win prizes,
              and have fun while learning. Perfect for brands looking to boost engagement and create
              memorable experiences.
            </p>

            <div className="space-y-4">
              {features.map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  animate={inView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.4, delay: 0.2 + index * 0.1 }}
                  className="flex items-center gap-3"
                >
                  <div className="w-6 h-6 rounded-full bg-brand-orange/20 flex items-center justify-center">
                    <Check className="w-4 h-4 text-brand-orange" />
                  </div>
                  <span className="text-gray-700">{feature}</span>
                </motion.div>
              ))}
            </div>
          <button onClick={() => window.open("https://www.whowantstoplaygh.com/", "_blank")} className="mt-10 px-6 py-3 bg-brand-orange text-white rounded-lg font-medium hover:bg-brand-orange-dark transition-colors duration-300">
             Play Now
          </button>
          </motion.div>

          {/* Right Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="relative rounded-3xl overflow-hidden shadow-2xl"
          >
            {/* aspect-ratio keeps height proportional on all screen sizes */}
            <div className="aspect-[4/3] w-full overflow-hidden rounded-3xl">
              <motion.img
                src={Images.play}
                alt="Trivia Game"
                className="w-full h-full object-cover"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.4 }}
              />
            </div>
            <div className="absolute bottom-6 right-6 bg-white/20 backdrop-blur-md rounded-full p-4">
              <Trophy className="w-16 h-16 text-yellow-400" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default DigitalProductsSection;